import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

const plugin = (chart) => {
  let height = chart.chart.height
  let ctx = chart.chart.ctx

  ctx.restore()

  let fontSize = (height / 300).toFixed(2)
  ctx.font = fontSize + 'em sans-serif'
  ctx.textBaseline = 'middle'
  ctx.textAlign = 'center'

  let text = `Tipos de\n Procedimentos`
  let textX = ((chart.chartArea.left + chart.chartArea.right) / 2)
  let textY = height / 2.3
  let lines = text.split('\n')
  let lineHeight = 25

  for (var i = 0; i < lines.length; i++) {
    ctx.fillText(lines[i], textX, textY + (i * lineHeight))
  }

  ctx.save()
}

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    this.addPlugin({
      id: 'my-plugin',
      beforeDraw: plugin
    })
    // this.chartData é criado no mixin.
    // Se você deseja passar opções, crie um objeto de opções locais
    this.renderChart(this.chartData, this.options)
  }
}
